import { render } from "./AdminRiderEdit.vue?vue&type=template&id=9a99aaac&scoped=true&ts=true&lang=true"
import script from "./AdminRiderEdit.vue?vue&type=script&lang=ts"
export * from "./AdminRiderEdit.vue?vue&type=script&lang=ts"

import "./AdminRiderEdit.vue?vue&type=style&index=0&id=9a99aaac&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a99aaac"]])

export default __exports__